module.exports = __webpack_public_path__ + "img/iluminacion.f4303f64.png";